import React, { Component } from 'react';
import Header from '../../components/header/Header'
import Lojas from '../../components/lojas/Lojas';
import Loading from '../../components/loading/Loading'
import './Home.css';
import API from '../../API/Api'
import Requests from "../../services/requests"
import services from './../../services/index';

import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as Actions from "../../store/actions"

import { withRouter } from "react-router-dom";
import { isEmpty } from "lodash"


class Home extends Component {

  state = {
    cep: '',
    scroll: 0,
    lojas: [],
    bkLojas: [],
    logado: false,
    loading: false,
    loadingPage: false
  }

  static defaultProps = {
    logado: false,
  }



  componentDidMount = async () => {
    services.setAskPromo(false);
    var AllStores = [];

    this.setState({ loadingPage: true });

    const lojas = await Requests.getStores();

    if (lojas.error) {
      return alert('Ops... Algo deu errado. Vamos tentar novamente');
    }

    if (lojas.length === 0) {
      return alert('Ops... Nenhuma loja encontrada');
    }


    if (await services.isLogado()) {
      try {

        const user = services.getUser();
        if (!isEmpty(user)) {
          if (!isEmpty(this.props.rdUser)) {
            this.props.setUserLogado(user.dados_cli);
            this.props.setAdressUser(user.enderecos);
          }
        }


        if ('enderecos' in user) {
          let enderecos = user.enderecos;
          let indexAdress = 0;

          if (enderecos.length > 0) {
            indexAdress = enderecos.findIndex(e => e.principal === 1 || e.principal === true);
            if (indexAdress === -1) {
              enderecos[0].principal = true;
            }
          }

          if (lojas.length === 1) {
            this.setState({ loadingPage: false });
            this.props.setStores(lojas);
            services.setLastStore(JSON.stringify(lojas));

            return this.props.history.push('LancaPedido');

          }

          AllStores = await services.returnNextStore(lojas, enderecos[indexAdress !== -1 ? indexAdress : 0].cep);

        }

        if (lojas.length > 0 && AllStores.length > 0) {
          if (AllStores.length === 1) {
            this.setState({ loadingPage: false });
            this.props.setStores(AllStores[0]);
            services.setLastStore(JSON.stringify(AllStores));
            this.props.history.push('LancaPedido');
            return;
          }
          this.setState({ lojas: AllStores });
        }

        this.setState({ logado: true });
        services.setLogado(true);

      } catch (error) {
        console.log(error);
      }

    } else {
      if (lojas.length === 1) {
        services.setLogado(false);
        this.setState({ loadingPage: false });
        this.props.setStores(lojas);
        services.setLastStore(JSON.stringify(lojas));
        this.props.history.push('LancaPedido');
        return;
      }

      AllStores = lojas;
      this.setState({ lojas: AllStores, allLojas: lojas });
    }

    this.setState({ loadingPage: false });
  }




  handleCep = (e) => {
    if (e.target.validity.valid)
      this.setState({ cep: e.target.value }, () => {
        const cep = this.state.cep;
        if (cep === '') {
          this.setState({ lojas: this.state.allLojas });
        }
      });
  }




  cepResolve = async () => {
    this.setState({ loading: true });
    let enderecoInfo = {};
    enderecoInfo = await services.consultaCep(this.state.cep);

    if (enderecoInfo) {
      let lojasProximas = [];

      const lojas = this.state.allLojas;
      const cep = this.state.cep;


      lojasProximas = await services.returnNextStore(lojas, cep);

      if (lojasProximas.length > 0) this.setState({ lojas: lojasProximas })
      else {
        alert('Não foi encontrada nenhuma loja próxima');
      }
    }
    this.setState({ loading: false });
  }

  handleKeyUp = async (event) => {
    if (event.keyCode === 13) {
      this.cepResolve();
    }
  }






  render() {
    return (
      <div>

        {
          this.state.loadingPage ? (
            <Loading />
          ) : ''
        }

        <Header logado={this.state.logado} where="principal" />

        {
          !this.state.logado ? (
            <section className="banner">
              <h2>Encontre uma loja próxima</h2>

              <div className="box-cep">
                <input
                  className="inputCeps cleanComponent"
                  maxLength="8" pattern="[0-9]*"
                  type="text"
                  placeholder="Informe o CEP"
                  value={this.state.cep}
                  onKeyUp={this.handleKeyUp}
                  onChange={this.handleCep}
                />
                <button
                  type="button"
                  onClick={this.consultaCep}
                  className="btn-pesq-cep" >
                  {this.state.loading ? <img alt="gif" src="assets/25.gif" /> : ''}
                </button>
              </div>
            </section>
          ) : (
            <section className="banner">
              <h2>PEDIDOS MENSA EM CASA</h2>
            </section>
          )
        }



        {
          !this.state.logado ? <h2 className="titleChangeSect">Confira nossas Unidades</h2> :

            this.state.lojas.length !== 0 ? <h2 className="titleChangeSect">Lojas próxima a você</h2> :
              <h2 className="titleChangeSect">Infelizmente não encontramos nenhuma loja próxima</h2>
        }


        <section
          className="container"
          style={{
            borderTop: '1px solid #999',
            padding: '20px 0 12px',
          }}
        >
          <Lojas data={this.state.lojas} logado={this.state.logado} />
        </section>



        {/* <input type="file" onChange={this.handleFileUpload} /> */}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  rdUser: state.user
})

const mapDispathToPros = dispatch => bindActionCreators(Actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispathToPros)(Home))

